import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'
import Svg from '@argos/svg'
import { Pill } from '@boltui/pills'

import logoFacebook from '@argos/icons/src/logo-facebook.svg'
import logoTwitter from '@argos/icons/src/logo-twitter.svg'

const cn = bem({ prefix: 'lc-', block: 'social-btn' })

class SocialButton extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['Facebook', 'Twitter']),
    url: PropTypes.string,
  }

  static defaultProps = {
    type: 'Facebook',
  }

  constructor(props) {
    super(props)

    this.buttons = {
      Facebook: {
        label: 'Facebook',
        style: '#4267B2',
        logo: logoFacebook,
      },
      Twitter: {
        label: 'Twitter',
        style: '#1DA1F3',
        logo: logoTwitter,
      },
    }
  }

  render() {
    const { type, url } = this.props
    const btnInfo = this.buttons[type]

    return (
      <Pill
        role='button'
        title={btnInfo.label}
        href={url}
        target='_blank'
        className={cn()}
        label={
          <React.Fragment>
            <span className={cn('logo')}>
              <Svg>{btnInfo.logo}</Svg>
            </span>
            {btnInfo.label}
          </React.Fragment>
        }
      />
    )
  }
}

export default SocialButton
